import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "iconRightChevron",
  "use": "iconRightChevron-usage",
  "viewBox": "0 0 9 15",
  "content": "<symbol viewBox=\"0 0 9 15\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"iconRightChevron\">\n<path d=\"M7.07025 5.65616L1.41408 -3.62174e-06L-0.000131919 1.41421L5.65603 7.07037L-0.000131919 12.7265L1.41408 14.1408L7.07025 8.48459L7.07094 8.48528L8.48515 7.07106V7.06968L7.07094 5.65547L7.07025 5.65616Z\" fill=\"#2D2D2D\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol